import _ from 'lodash';

import {
  getFieldChecked,
  getFieldType,
  getFieldValue,
  getFieldName
} from './utils';
import {
  getPricingSummary,
  getVulcanPriceSelections
} from './vulcanPricing/vulcanPricing';
import {
  keyControlAdditionalEquipmentVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  keyControlIncludedEquipmentVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyMonitorIncludedEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  keyProtectIncludedEquipmentVulcan
} from '../utils/constant';

export const isRelatedFieldExisted = (
  field,
  fields,
  orderData,
  isFormTouched
) => {
  const {
    appearsAfterField,
    appearsAfterValue,
    backendFieldValidation
  } = field;

  if (!appearsAfterField && !backendFieldValidation) return true;

  let result = true;
  let i = 0;
  if (appearsAfterField) {
    while (i < appearsAfterField.length && result) {
      const relatedFieldName = getFieldName(appearsAfterField[i]);
      const relatedFieldType = getFieldType(relatedFieldName, fields);
      const relatedFieldValue =
        relatedFieldType === 'Checkbox'
          ? getFieldChecked(relatedFieldName, fields)
          : getFieldValue(relatedFieldName, fields);

      if (relatedFieldName) {
        if (
          fields[relatedFieldName] &&
          fields[relatedFieldName].isVisible &&
          relatedFieldValue
        ) {
          if (appearsAfterValue) {
            let isValueSelected;
            if (_.isArray(relatedFieldValue)) {
              isValueSelected = appearsAfterValue.find(item =>
                relatedFieldValue.includes(item.fields.value)
              );
            } else {
              isValueSelected = appearsAfterValue.find(
                item => relatedFieldValue === item.fields.value
              );
            }
            result = result && typeof isValueSelected !== 'undefined';
          }
        } else if (orderData && orderData[relatedFieldName]) {
          if (fields[relatedFieldName]) {
            if (
              (isFormTouched &&
                orderData[relatedFieldName] === relatedFieldValue) ||
              !isFormTouched
            ) {
              if (appearsAfterValue) {
                const isValueSelected = appearsAfterValue.find(
                  item => orderData[relatedFieldName] === item.fields.value
                );
                result = result && typeof isValueSelected !== 'undefined';
              }
            } else result = false;
          } else if (appearsAfterValue) {
            const isValueSelected = appearsAfterValue.find(
              item => orderData[relatedFieldName] === item.fields.value
            );
            result = result && typeof isValueSelected !== 'undefined';
          }
        } else {
          result = false;
        }
      }
      i += 1;
    }
  }

  if (backendFieldValidation) {
    let isVisible = result;
    for (let index = 0; index < backendFieldValidation.length; index += 1) {
      const {
        fields: { key, value }
      } = backendFieldValidation[index];
      isVisible =
        isVisible &&
        (value.split('|').includes(orderData[key]) ||
          (value.split('|').includes('undefined') &&
            typeof orderData[key] === 'undefined'));
    }
    return isVisible;
  }

  return result;
};

const removeUnusedSelectionsIncludedEquipments = obj =>
  Object.entries(obj)
    .filter(([, value]) => !!value)
    .reduce((acc, item) => ({ ...acc, [item[0]]: item[1] }), {});

const getEquipmentGroupFormData = obj => {
  const result = Object.keys(obj)
    .filter(
      key =>
        (obj[key] || {}).isVisible &&
        typeof (obj[key] || {}).value !== 'undefined'
    )
    .reduce((acc, key) => {
      const { value } = obj[key];
      acc[key] = value;
      return acc;
    }, {});
  return result;
};

export const getFormData = (fields, step) => {
  const result = Object.keys(fields).reduce((acc, key) => {
    const { type, value, checked } = fields[key];
    acc[key] = type === 'Checkbox' ? checked : value || '';
    return acc;
  }, {});
  if (fields.files) {
    result.files = fields.files;
  }

  result.priceSelections = {
    ...result.priceSelections,
    ...getVulcanPriceSelections(fields)
  };

  // Handling Secure Business Selections
  if (fields[keyMonitorIncludedEquipmentVulcan]) {
    result[keyMonitorIncludedEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyMonitorIncludedEquipmentVulcan]
    );
    result[
      keyMonitorIncludedEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyMonitorIncludedEquipmentVulcan]
    );
  }
  if (fields[keyMonitorAdditionalEquipmentVulcan]) {
    result[keyMonitorAdditionalEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyMonitorAdditionalEquipmentVulcan]
    );
    result[
      keyMonitorAdditionalEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyMonitorAdditionalEquipmentVulcan]
    );
  }
  if (fields[keyProtectIncludedEquipmentVulcan]) {
    result[keyProtectIncludedEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyProtectIncludedEquipmentVulcan]
    );
    result[
      keyProtectIncludedEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyProtectIncludedEquipmentVulcan]
    );
  }
  if (fields[keyProtectIncludedEquipmentCameraSelectionVulcan]) {
    result[
      keyProtectIncludedEquipmentCameraSelectionVulcan
    ] = getEquipmentGroupFormData(
      fields[keyProtectIncludedEquipmentCameraSelectionVulcan]
    );
    result[
      keyProtectIncludedEquipmentCameraSelectionVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyProtectIncludedEquipmentCameraSelectionVulcan]
    );
  }
  if (fields[keyProtectAdditionalEquipmentVulcan]) {
    result[keyProtectAdditionalEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyProtectAdditionalEquipmentVulcan]
    );
    result[
      keyProtectAdditionalEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyProtectAdditionalEquipmentVulcan]
    );
  }
  if (fields[keyControlIncludedEquipmentVulcan]) {
    result[keyControlIncludedEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyControlIncludedEquipmentVulcan]
    );
    result[
      keyControlIncludedEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyControlIncludedEquipmentVulcan]
    );
  }
  if (fields[keyControlAdditionalEquipmentVulcan]) {
    result[keyControlAdditionalEquipmentVulcan] = getEquipmentGroupFormData(
      fields[keyControlAdditionalEquipmentVulcan]
    );
    result[
      keyControlAdditionalEquipmentVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyControlAdditionalEquipmentVulcan]
    );
  }
  if (fields[keyControlIncludedEquipmentCameraSelectionVulcan]) {
    result[
      keyControlIncludedEquipmentCameraSelectionVulcan
    ] = getEquipmentGroupFormData(
      fields[keyControlIncludedEquipmentCameraSelectionVulcan]
    );
    result[
      keyControlIncludedEquipmentCameraSelectionVulcan
    ] = removeUnusedSelectionsIncludedEquipments(
      result[keyControlIncludedEquipmentCameraSelectionVulcan]
    );
  }

  if (step === 1) {
    result.priceSummary = getPricingSummary(fields || {});
  }

  return result;
};
